import { GEM_MODE_POWERUP_WEIGHTS, BASIC_BALANCE } from '../../shared/game-balance.js';

const DEFAULT_CONFIG = {
  fieldWidth: BASIC_BALANCE.fieldWidth,
  fieldHeight: BASIC_BALANCE.fieldHeight,
  tickMs: BASIC_BALANCE.tickMs,
  speedStackBonus: BASIC_BALANCE.speedPowerupSpeedMultiplier - 1,
  speedTurnRadiusMul: BASIC_BALANCE.speedPowerupTurnRadiusMultiplier,
  speedMaxStacks: BASIC_BALANCE.speedPowerupMaxStacks,
  speedEffectTicks: Math.max(
    1,
    Math.round((BASIC_BALANCE.speedPowerupDurationSeconds * 1000) / BASIC_BALANCE.tickMs)
  ),
  trailSize: BASIC_BALANCE.trailSize,
  powerupRadius: BASIC_BALANCE.powerupRadius,
  powerupSpawnFrequencyPerSecond: BASIC_BALANCE.powerupSpawnFrequencyPerSecond,
  powerupWeights: GEM_MODE_POWERUP_WEIGHTS,
  gemRoundDurationMs: 2 * 60 * 1000,
  respawnDelayMs: 1500,
  respawnSafeMs: 2440,
  firstToPercent: BASIC_BALANCE.firstToPercent,
  pointsPerSurvive: BASIC_BALANCE.pointsPerSurvive,
  pointsPerKill: BASIC_BALANCE.pointsPerKill,
  eraseDeadLines: BASIC_BALANCE.eraseDeadLines,
  alwaysActivePowerups: BASIC_BALANCE.alwaysActivePowerups,
  bikeSpeed: BASIC_BALANCE.bikeSpeed,
  turnRadius: BASIC_BALANCE.turnRadius,
  steerRampMs: 0
};

const HEAD_SPAWN_TIMER_MS = 200;
const HEAD_SPAWN_ALPHA_MS = 100;
const HEAD_SPAWN_SCALE_DELAY_MS = 200;
const HEAD_SPAWN_SCALE_MS = 300;
const HEAD_SPAWN_MARKER_FALLBACK_MS = 3000;
const POWERUP_SPAWN_ANIM_MS = 750;
const POWERUP_RADIUS = BASIC_BALANCE.powerupRadius;
const EFFECT_RING_SEGMENTS = 32;
const EFFECT_RING_DISTANCE_STEP = 4;
const EFFECT_RING_DISTANCE_OFFSET = 6;
const EFFECT_RING_LINE_WIDTH = 3;
const EFFECT_RING_MAX_STACKS = 30;
const EFFECT_RING_SPEED_COLOR = '#baffc4';
const EFFECT_RING_SPEED_GLOW = 'rgba(134, 202, 54, 0.45)';

const PU_TYPES = {
  SPEED: 'SPEED',
  CLEAR: 'CLEAR',
  GEM: 'GEM'
};

const PLAYER_FLAG_ALIVE = 1;
const PLAYER_FLAG_SPEED = 2;
const PLAYER_FLAG_LOCAL = 4;
const PLAYER_FLAG_DRAWING_TRAIL = 8;
const POWERUP_FLAG_CLEAR = 1;
const POWERUP_FLAG_GEM = 2;
const POWERUP_POS_STRIDE = 3;

export {
  DEFAULT_CONFIG,
  HEAD_SPAWN_TIMER_MS,
  HEAD_SPAWN_ALPHA_MS,
  HEAD_SPAWN_SCALE_DELAY_MS,
  HEAD_SPAWN_SCALE_MS,
  HEAD_SPAWN_MARKER_FALLBACK_MS,
  POWERUP_SPAWN_ANIM_MS,
  POWERUP_RADIUS,
  EFFECT_RING_SEGMENTS,
  EFFECT_RING_DISTANCE_STEP,
  EFFECT_RING_DISTANCE_OFFSET,
  EFFECT_RING_LINE_WIDTH,
  EFFECT_RING_MAX_STACKS,
  EFFECT_RING_SPEED_COLOR,
  EFFECT_RING_SPEED_GLOW,
  PU_TYPES,
  PLAYER_FLAG_ALIVE,
  PLAYER_FLAG_SPEED,
  PLAYER_FLAG_LOCAL,
  PLAYER_FLAG_DRAWING_TRAIL,
  POWERUP_FLAG_CLEAR,
  POWERUP_FLAG_GEM,
  POWERUP_POS_STRIDE
};
